<template>
  <div class="survey-start">
    <div v-if="personal" class="personal">
      <ContactForm
        v-model="personal"
        class="survey-form"
        checkEmpty="true"
        phone="true"
        email="true"
        name="true"
        path="/kerdoiv/bekoltozes"
        id="start"
      >
        <template #title>
          <h2 class="h1">A Te időd. <br />Az Offie előnye.</h2>
        </template>
        <template #description>
          <p>
            Töltsd ki 2 perces - 6 kérdésből álló kérdőívünket, és mi egy
            <strong>INGYENES</strong> személyre szabott, naprakész és
            ellenőrzött iroda listával 3 munkanapon belül felkeresünk Téged.
          </p>
          <p>
            Hogyha elakadnál nyugodtan keress minket és mi segítünk felmérni az
            igényeid, vagy töltsd le
            <a href="/offie_9tipp_1920x1080.pdf" target="_blank"
              >9 tippből álló segédanyagunkat</a
            >
            <!--a href="/#pdf-guide">9 tippből álló segédanyagunkat</a
            -->
          </p>
        </template>
        <template #content>
          <div class="flex flex-col items-center">
            <img
              alt="hi there"
              src="@/assets/hi-there.svg"
              width="261"
              height="184"
              title=""
            />
            <Button
              :disabled="checkEmpty && isEmpty"
              to="/kerdoiv/bekoltozes"
              :arrow="buttonArrow || 'right'"
              :class="buttonClass || 'blue fullwidth mt-8'"
              >Tovább a kérdőívhez</Button
            >
          </div>
        </template>
      </ContactForm>
      <!--router-link to="/kerdoiv/bekoltozes">Begin the form</router-link-->
    </div>
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";
import Button from "@/components/inputs/Button.vue";

export default {
  name: "Start",
  props: ["buttonArrow", "buttonClass"],
  components: {
    ContactForm,
    Button
  },
  data() {
    return {
      personal: this.$store.getters.getPersonal,
      checkEmpty: null,
      isEmpty: null
    };
  },
  methods: {
    setPersonal(value) {
      // console.log("setPersonal", value);
      this.$store.commit("setPersonal", value);
    }
  }
};
</script>

<style lang="scss">
.survey-start {
  padding: 16px;
  .personal {
    padding: 0;
  }
  .form {
    text-align: center;
    &.survey-form {
      padding: 0;
      .form-desc {
        // order: 2;
      }
      form,
      .input-holder {
        // order: 3;
        flex-direction: column;
      }
      .form-description {
        p {
          margin: 0 16px 16px 0;
        }
      }
      .form-content {
        display: flex;
        order: 1;
        width: 100%;
        justify-content: center;
        margin-bottom: 24px;
        margin-top: 56px;
        img {
          max-width: 160px;
          height: auto;
        }
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    padding: 24px;
    .form {
      &.survey-form {
        flex-direction: column;
        // flex-wrap: wrap;
        justify-content: flex-start;
        align-items: stretch;
        height: 486px;
        height: 500px;
        //padding: 24px;
        .form-desc {
          order: 1;
          // width: 61%;
          // flex: 0 0 50%;
          .form-title {
            // width: 200%;
            margin-bottom: 28px;
          }
          br {
            display: none;
          }
        }
        .form-container {
          box-sizing: border-box;
          justify-content: space-between;
          order: 3;
          width: 39%;
          flex: 0 0 100%;
          padding: 0;
          // flex-direction: ;
          .button {
            //align-self: flex-end;
          }

          .form-row {
            margin: 0;
            padding-bottom: 16px;
            &:first-child {
              padding-top: 80px;
            }
            &:last-child {
              //flex: 0 0 20%;
              //height: calc(100% - 48px);
              // margin: 0;
              //flex: 0 0 40%;
              height: 100%;
              padding: 0;
              align-items: flex-end;
              .form-label {
                height: 100%;
                // flex: 0 0 100%
              }
            }
          }
        }
        .form-content {
          order: 2;
          width: 100%;
          flex: 0 0 40%;
          justify-content: center;
          align-items: center;
          margin-block-start: 0;
          img {
            max-width: 270px;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
